
const loadPdfLibDocument = async () => {
	const [{ PDFDocument }] = await Promise.all([
		import('@cantoo/pdf-lib')
	]);
	return { PDFDocument };
}

const loadPdfLibFontKit = async () => {
	const [{ default: fontkit }] = await Promise.all([
		import('@pdf-lib/fontkit')
	]);
	return { fontkit };
}

export { loadPdfLibDocument, loadPdfLibFontKit };